<template lang="pug">
    d2-container
        template(slot="header") 基础表格
        d2-crud(ref="d2Crud" :columns="columns" :data="data")
        el-card.d2-mb(shadow="never")
            d2-markdown(:source="doc")
        el-card.d2-mb(shadow="never")
            d2-highlight(:code="code")
        template(slot="footer")
            d2-link-btn(title="文档" link="https://d2-projects.github.io/d2-admin-doc/zh/ecosystem-d2-crud/")
</template>

<script>
import doc from './doc.md'
import code from './code.js'

export default {
  data () {
    return {
      doc,
      code,
      columns: [
        {
          title: '日期',
          key: 'date',
          width: '180'
        },
        {
          title: '姓名',
          key: 'name',
          width: '180'
        },
        {
          title: '地址',
          key: 'address'
        }
      ],
      data: [
        {
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        },
        {
          date: '2016-05-04',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1517 弄'
        },
        {
          date: '2016-05-01',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1519 弄'
        },
        {
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1516 弄'
        }
      ]
    }
  },
  mounted () {
    console.log(this.$refs.d2Crud.d2Data)
  }
}
</script>
